import React, { createContext, useState } from "react";
import { v4 as uuidv4 } from 'uuid';

export const ElementContext = createContext();

const ElementProvider = ({ children }) => {
  const [clickedElement, setElement] = useState();
  const [isDragging, toggleDragging] = useState();
  const clickElement = element => {
    let newElement = JSON.parse(JSON.stringify(element)); // Deep copying an Object
    newElement.clickedId = uuidv4();
    setElement(newElement);
  };
  return (
    <ElementContext.Provider value={{ clickedElement, clickElement, isDragging, toggleDragging }}>
      {children}
    </ElementContext.Provider>
  );
};

export default ElementProvider;